export interface Region {
    id: number;
    name: string;
    checked: boolean;
    isSelectable: boolean;
    isExpanded: boolean;
    utilityId: number;
    code: string;
    number: string;
    longitude: number | null;
    latitude: number | null;
}

export function getInitRegion(): Region {
    return {
        id: 0,
        name: '',
        checked : true,
        isSelectable: false,
        isExpanded: false,
        utilityId: 0,
        code: '',
        number: '',
        longitude: null,
        latitude: null
    };
}
